import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { statusColor, docsObrigatoriosFaltando } from "./constants";
import { DocumentosChecklist } from "./DocumentosChecklist";
import { TimelineInscricao } from "./TimelineInscricao";
import { InscricaoResumo } from "./InscricaoResumo";

function CardTabs({ tabs, active, onChange, inscricaoId }) {
  return (
    <div className="flex gap-2 mt-3 border-b -mb-6">
      {tabs.map((t) => (
        <button
          key={t.k}
          onClick={() => onChange(t.k)}
          className={`px-3 py-2 text-xs font-semibold border-b-2 transition-colors ${
            active === t.k ? "border-[#083CA6] text-[#083CA6]" : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
          data-testid={`tab-${t.k}-${inscricaoId}`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function InscricaoCard({ inscricao, editTel, setEditTel, onReload, onDocChange }) {
  const [aba, setAba] = useState("resumo");
  const faltando = docsObrigatoriosFaltando(inscricao.documentos).length;
  const tabs = [
    { k: "resumo", label: "Resumo" },
    { k: "docs", label: `Documentos${faltando ? ` (${faltando} faltando)` : ""}` },
    { k: "timeline", label: "Histórico" },
  ];

  return (
    <Card data-testid={`cidadao-card-${inscricao.id}`}>
      <CardHeader>
        <div className="flex items-start justify-between flex-wrap gap-3">
          <div>
            <CardTitle className="font-mono text-base">{inscricao.protocolo}</CardTitle>
            <CardDescription>Inscrição em {new Date(inscricao.created_at).toLocaleDateString("pt-BR")}</CardDescription>
          </div>
          <Badge className={statusColor(inscricao.status)} data-testid={`cidadao-status-${inscricao.id}`}>
            {inscricao.status}
          </Badge>
        </div>
        <CardTabs tabs={tabs} active={aba} onChange={setAba} inscricaoId={inscricao.id} />
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {aba === "resumo" && (
          <InscricaoResumo inscricao={inscricao} editTel={editTel} setEditTel={setEditTel} onReload={onReload} />
        )}
        {aba === "docs" && <DocumentosChecklist inscricao={inscricao} onDocChange={onDocChange} />}
        {aba === "timeline" && <TimelineInscricao inscricaoId={inscricao.id} />}
      </CardContent>
    </Card>
  );
}
